import types from './types';

const INITIAL_STATE = {
  isFetchingList: false,

  result: [],
};

const authCityReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {

    case types.GET_CITY_LIST_REQUEST:
      return {
        ...state,
        result: [],
        isFetchingList: true,
      };

    case types.GET_CITY_LIST_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetchingList: false,
      };

    case types.GET_CITY_LIST_FAILURE:
      return {
        ...state,
        result: [],
        isFetchingList: false,
      };

    default:
      return state;
  }
};

export default authCityReducer;
